import React from 'react';
const zIndexContext = /*#__PURE__*/React.createContext(undefined);
export default zIndexContext;